import { useSearch } from '@tanstack/react-router';

export const useOpenPanel = () => {
  const search = useSearch({ strict: false });
  const agentRunsPanelOpen = search?.showPanel === 'agent-runs';
  const emailPanelOpen = search?.showPanel === 'email';
  return { agentRunsPanelOpen, emailPanelOpen };
};
